/** @jsxRuntime classic */ /** @jsxRuntime classic */
/** @jsx jsx */
/**
 * Copied over from @theme-ui/components and adapted.
 *  @see https://github.com/system-ui/theme-ui/blob/master/packages/components/src/Grid.js
 */
import { jsx } from 'theme-ui';
import Box from './Box';

const px = (n) => (typeof n === 'number' ? n + 'px' : n);

const widthToColumns = (width, repeat) =>
  Array.isArray(width)
    ? width.map((w) => widthToColumns(w, repeat))
    : !!width && `repeat(auto-${repeat}, minmax(${px(width)}, 1fr))`;

const countToColumns = (n) =>
  Array.isArray(n)
    ? n.map(countToColumns)
    : !!n && (typeof n === 'number' ? `repeat(${n}, 1fr)` : n);

/**
 * Creates a css grid.
 * @param {object} props
 * @param {number | string | Array<number | string>} [props.width] The width of the columns.
 * @param {number | string} [props.height] The height of the columns.
 * @param {number | number[]} [props.columns] The number of equal-sized columns.
 * @param {number | string} [props.gap] The gap between the columns, measured in the spacing scale.
 * @param {'fit' | 'fill'} [props.repeat] 'fit' uses the auto-fit algorithm that maximizes the content, whereas 'fill' maximizes the number of columns. See also https://css-tricks.com/auto-sizing-columns-css-grid-auto-fill-vs-auto-fit/
 * @param {React.ReactNode} [props.children] The grid elements.
 * @returns {React.ReactElement}
 */
export default function Grid({
  width,
  height,
  columns,
  gap = 3,
  repeat = 'fit',
  ...props
}) {
  const gridTemplateColumns = !!width
    ? widthToColumns(width, repeat)
    : countToColumns(columns);

  return (
    <Box
      sx={{
        display: 'grid',
        gap,
        gridTemplateColumns,
        ...(typeof height === 'number' && {
          gridAutoRows: `minmax(${height}px, auto)`,
        }),
      }}
      {...props}
    />
  );
}
